module.exports = __webpack_public_path__ + "img/logo.46f1d7c8.svg";